import nodataDe from 'plugins/i18n/locales/component/templates/nodata.de.ts'
import editorDe from 'plugins/i18n/locales/component/elements/editor.de.ts'
import notificationsDe from 'plugins/i18n/locales/component/elements/notifications.de.ts'
import activityFeedDe from 'plugins/i18n/locales/component/modules/activityFeed/activityFeed.de.ts'
import profileDe from 'plugins/i18n/locales/component/modules/profile/profile.de.ts'
import propertymanagersDe from 'plugins/i18n/locales/component/modules/propertymanagers.de.ts'
import readConfirmationsDe from 'plugins/i18n/locales/component/modules/readConfirmations.de.ts'
import reportDe from 'plugins/i18n/locales/component/modules/pendingRequest/reports/reports.de.ts'
import notesDe from 'plugins/i18n/locales/component/modules/notes/notes.de.ts'
import loginDe from 'plugins/i18n/locales/component/modules/login/login.de.ts'
import dashboardDe from 'plugins/i18n/locales/component/modules/dashboard/dashboard.de.ts'
import buildingsDe from 'plugins/i18n/locales/component/modules/buildings/buildings.de.ts'
import personsDe from 'plugins/i18n/locales/component/modules/persons/persons.de.ts'
import documentsDe from 'plugins/i18n/locales/component/modules/documents/documents.de.ts'
import craftsmanTasksDe from 'plugins/i18n/locales/component/modules/craftsmanTasks/craftsmanTasks.de.ts'
import reviewDocumentDe from 'plugins/i18n/locales/component/modules/reviewDocuments/reviewDocuments.de.ts'
import commentsDe from 'plugins/i18n/locales/component/modules/comments/comments.de.ts'
import accountsDe from 'plugins/i18n/locales/component/modules/accounts/accounts.de.ts'
import managementDe from 'plugins/i18n/locales/component/modules/management/management.de.ts'
import syncFailuresDe from 'plugins/i18n/locales/component/modules/management/syncFailures.de.ts'
import accessRejectionsDe from 'plugins/i18n/locales/component/modules/management/accessRejections.de.ts'
import tasksDe from 'plugins/i18n/locales/component/modules/tasks/tasks.de.ts'
import teamsDe from 'plugins/i18n/locales/component/modules/teams/teams.de.ts'
import rolepermissionDe from 'plugins/i18n/locales/component/modules/persons/rolepermission.de.ts'
import subscriptionsDe from 'plugins/i18n/locales/component/modules/subscriptions/subscriptions.de.ts'
import drawerDe from 'plugins/i18n/locales/component/elements/drawer.de.ts'
import faqsDe from 'plugins/i18n/locales/component/modules/faqs/faqs.de.ts'
import toastDe from 'plugins/i18n/toast.de.ts'
import consumptionDe from 'plugins/i18n/locales/component/modules/consumption.de.ts'
import unitsDe from 'plugins/i18n/locales/component/modules/units/units.de.ts'
import liaDe from 'plugins/i18n/locales/component/elements/lia.de.ts'
import cookieDe from 'plugins/i18n/locales/component/elements/cookie.de.ts'
import errorDe from 'plugins/i18n/locales/component/elements/error.de.ts'
import invoiceDe from 'plugins/i18n/locales/component/modules/buildings/invoice.de.ts'
import metersDe from 'plugins/i18n/locales/component/modules/buildings/meters.de.ts'
import updateDialogDe from 'plugins/i18n/locales/component/modules/updateDialog.de.ts'
import legacySyncBannerDe from 'plugins/i18n/locales/component/modules/legacySyncBanner.de.ts'
import datatableDe from 'plugins/i18n/locales/component/templates/datatable.de.ts'
import exportDe from 'plugins/i18n/locales/component/templates/export.de.ts'
import passwordConfirmationDe from 'plugins/i18n/locales/component/templates/passwordConfirmation.de.ts'
import sitePolicyDe from 'plugins/i18n/locales/component/modules/sitePolicy.de.ts'
import addressesDe from 'plugins/i18n/locales/component/modules/addresses/addresses.de.ts'
import baseImage from './baseImage'

const component = {
	...nodataDe,
	...editorDe,
	...notificationsDe,
	...activityFeedDe,
	...profileDe,
	...propertymanagersDe,
	...readConfirmationsDe,
	...reportDe,
	...notesDe,
	...loginDe,
	...dashboardDe,
	...buildingsDe,
	...personsDe,
	...documentsDe,
	...craftsmanTasksDe,
	...reviewDocumentDe,
	...commentsDe,
	...accountsDe,
	...managementDe,
	...syncFailuresDe,
	...accessRejectionsDe,
	...tasksDe,
	...teamsDe,
	...rolepermissionDe,
	...subscriptionsDe,
	...drawerDe,
	...faqsDe,
	...toastDe,
	...unitsDe,
	...consumptionDe,
	...liaDe,
	...cookieDe,
	...errorDe,
	...invoiceDe,
	...metersDe,
	...updateDialogDe,
	...legacySyncBannerDe,
	...datatableDe,
	...exportDe,
	...passwordConfirmationDe,
	...sitePolicyDe,
	...addressesDe,
	locale: {
		name: 'Sprache auswählen',
		icon: 'fal fa-language',
		language: 'Sprache',
		de: 'Deutsch',
		en: 'Englisch',
	},
	theme: {
		name: 'Darstellung',
		icon: 'fas fa-palette',
		client: 'Hausverwaltung',
		light: 'Hell',
		dark: 'Dunkel',
		system: 'Gerätedesign',
	},
	baseImage: baseImage.de,
}

export default component
